import { useContext } from 'react';

import { DataContext } from '@visx/xychart';

import { AreaSeries } from './AreaSeries';
import { LineSeries } from './LineSeries';

import type { Money } from '@betterment/core';

export type BalanceChartData = {
  date: Date;
  balance: Money;
  invested: Money;
}[];

const dateAccessor = (d: BalanceChartData[number]) => d.date;
const investedAccessor = (d: BalanceChartData[number]) => d.invested.cents;
const balanceAccessor = (d: BalanceChartData[number]) => d.balance.cents;

export const BalanceChartDataSeries = ({
  data,
  balanceDataKey,
  investedDataKey,
}: {
  data: BalanceChartData;
  balanceDataKey: string;
  investedDataKey: string;
}) => {
  const context = useContext(DataContext);
  const portfolioColor = context?.theme?.colors?.[0];
  return (
    <>
      <LineSeries
        dataKey={investedDataKey}
        data-testid="investor-line"
        data={data}
        xAccessor={dateAccessor}
        yAccessor={investedAccessor}
        color={portfolioColor}
        variant="dashed"
      />
      <AreaSeries
        dataKey={balanceDataKey}
        data-testid="balance-area"
        data={data}
        xAccessor={dateAccessor}
        yAccessor={balanceAccessor}
        color={portfolioColor}
      />
    </>
  );
};
